module.exports = __webpack_public_path__ + "static/media/folder2.536f98bf.png";